module.exports = __webpack_public_path__ + "img/MySQL.0a171f9.svg";